
import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';

const Sidebar = props => {
  const className = classnames('Sidebar', {'is-wider': props.isWider});

  return (
    <div className={className}>
      {props.children}
    </div>
  );
};

Sidebar.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  isWider: PropTypes.bool
};

export default Sidebar;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Sidebar/index.js
 **/